// @flow
import type { MessageDescriptor } from 'react-intl';

const prefix = 'tagFilters';

export default {
  clearButton: ({
    id: `${prefix}.labels.clearButton`,
    defaultMessage: 'Limpiar filtros',
    description: 'Clear filters button text',
  }: MessageDescriptor),
  withoutCategory: ({
    id: `${prefix}.labels.withoutCategory`,
    defaultMessage: 'Sin categoria',
    description: 'Displays when tag has no category',
  }: MessageDescriptor),
};
